/*
  The help pages (round 47): sections/vr-faq, sections/vr-care, sections/vr-help-opening, snippets/vr-policy-frame,
  with assets/vr-help.css.
  - The row of the help pages starts at the page showing when it slides sideways on phones.
  - The questions open and close smoothly.
  - The topics beside a long page follow the reading: the FAQs list their topics in the page; a policy with four
    sections or more gets its list built from its headings ("On this page").
  - On phones and tablets a long list (more than seven sections) folds under its own line.
*/
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ease = 'cubic-bezier(0.22, 0.61, 0.36, 1)';
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };
  var small = window.matchMedia('(max-width: 989.98px)');
  var slug = function (t) { return String(t).toLowerCase().replace(/&[a-z]+;/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 48); };

  /* ---- the row of the help pages: on phones it starts at the page showing ---- */
  function nav(root) {
    var list = root.querySelector('.vhd-nav__list');
    var cur = list && list.querySelector('[aria-current="page"]');
    if (!list || !cur || list.scrollWidth <= list.clientWidth + 2) return;
    var li = cur.parentElement;
    list.scrollLeft = Math.max(0, li.offsetLeft - (list.clientWidth - li.offsetWidth) / 2);
  }

  /* ---- the questions open and close smoothly ---- */
  function questions(root) {
    each(root.querySelectorAll('.vhd-q'), function (q) {
      var head = q.querySelector('summary');
      var body = q.querySelector('.vhd-q__body');
      if (!head || !body || reduce || !body.animate) return;
      head.addEventListener('click', function (e) {
        e.preventDefault();
        if (q.open) {
          var h = body.offsetHeight;
          var a = body.animate([{ height: h + 'px' }, { height: '0px' }], { duration: 450, easing: ease });
          a.onfinish = function () { q.open = false; };
        } else {
          q.open = true;
          var h2 = body.offsetHeight;
          body.animate([{ height: '0px' }, { height: h2 + 'px' }], { duration: 450, easing: ease });
        }
      });
    });
  }

  /* ---- a policy's own list of its sections, built from its headings ---- */
  function policyIndex(root) {
    var container = root.querySelector('.shopify-policy__container');
    var rte = root.querySelector('.shopify-policy__body .rte');
    if (!container || !rte || root.querySelector('[data-vhd-index]')) return null;
    var heads = Array.prototype.filter.call(rte.querySelectorAll('h2'), function (h) { return !h.closest('.vr-policy__contact') && h.textContent.trim(); });
    if (heads.length < 4) return null;
    var nav = document.createElement('nav');
    nav.className = 'vhd-index';
    nav.setAttribute('aria-label', 'On this page');
    nav.setAttribute('data-vhd-index', '');
    var label = document.createElement('p');
    label.className = 'vhd-index__label';
    label.textContent = 'On this page';
    var ol = document.createElement('ol');
    ol.className = 'vhd-index__list';
    ol.setAttribute('role', 'list');
    heads.forEach(function (h, i) {
      if (!h.id) h.id = 'section-' + (i + 1) + '-' + slug(h.textContent);
      h.setAttribute('data-vhd-topic', '');
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'vhd-index__link';
      a.href = '#' + h.id;
      var no = document.createElement('span');
      no.className = 'vhd-index__no';
      no.setAttribute('aria-hidden', 'true');
      no.textContent = (i < 9 ? '0' : '') + (i + 1);
      var name = document.createElement('span');
      name.className = 'vhd-index__name';
      name.textContent = h.textContent.replace(/^\s*\d+\.\s*/, '').trim();
      a.appendChild(no);
      a.appendChild(name);
      li.appendChild(a);
      ol.appendChild(li);
    });
    nav.appendChild(label);
    if (heads.length > 7) {
      ol.id = 'VhdIndexList';
      nav.classList.add('vhd-index--long');
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'vhd-index__toggle';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-controls', ol.id);
      toggle.innerHTML = '<span>On this page</span><span class="vhd-index__plus" aria-hidden="true"></span>';
      nav.appendChild(toggle);
    }
    nav.appendChild(ol);
    container.insertBefore(nav, container.firstChild);
    container.classList.add('has-index');
    return nav;
  }

  /* ---- a long list folds under its own line on phones and tablets ---- */
  function fold(idx) {
    var toggle = idx.querySelector('.vhd-index__toggle');
    var list = idx.querySelector('.vhd-index__list');
    if (!toggle || !list) return;
    var set = function (open) { idx.classList.toggle('is-open', open); toggle.setAttribute('aria-expanded', open ? 'true' : 'false'); };
    toggle.addEventListener('click', function () {
      var open = !idx.classList.contains('is-open');
      if (reduce || !list.animate) { set(open); return; }
      if (open) {
        set(true);
        var h = list.offsetHeight;
        list.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 520, easing: ease });
      } else {
        var h2 = list.offsetHeight;
        toggle.setAttribute('aria-expanded', 'false');
        var a = list.animate([{ height: h2 + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 450, easing: ease });
        a.onfinish = function () { set(false); };
      }
    });
    /* a section chosen from the list closes it first, so the page moves to where the section then is */
    list.addEventListener('click', function (e) { if (small.matches && e.target.closest('a')) set(false); });
  }

  /* ---- the topic being read: the last one whose start has passed a third of the way down the screen ---- */
  function follow(root) {
    var idx = root.querySelector('[data-vhd-index]') || policyIndex(root);
    if (!idx) return;
    fold(idx);
    var pairs = Array.prototype.map.call(idx.querySelectorAll('.vhd-index__link'), function (a) { return { a: a, t: document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1))) }; }).filter(function (p) { return p.t; });
    if (!pairs.length) return;
    var current = null;
    var tick = function () {
      var line = window.innerHeight * 0.34;
      var found = pairs[0];
      for (var i = 0; i < pairs.length; i++) { if (pairs[i].t.getBoundingClientRect().top <= line) found = pairs[i]; else break; }
      if (found !== current) {
        current = found;
        pairs.forEach(function (p) { p.a.classList.toggle('is-current', p === found); });
      }
    };
    var queued = false;
    window.addEventListener('scroll', function () { if (queued) return; queued = true; window.requestAnimationFrame(function () { queued = false; tick(); }); }, { passive: true });
    window.addEventListener('resize', tick);
    tick();
  }

  function init(root) {
    if (!root || root.getAttribute('data-vhd-ready')) return;
    root.setAttribute('data-vhd-ready', '1');
    nav(root);
    questions(root);
    follow(root);
  }
  var start = function () { each(document.querySelectorAll('[data-vhd]'), init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { each(e.target.querySelectorAll('[data-vhd]'), init); });
})();
